import moment from "moment-jalaali";
import React from "react";
import { SubstractMonth } from "utils/SubstractMonth";

const useKeepSelectedDateRange = (SelectRange, Range, setForceRender) => {
  React.useEffect(() => {
    const previousSearchDate = sessionStorage.getItem("previousSearchDate");
    if (previousSearchDate) {
      const prevDate = JSON.parse(sessionStorage.getItem("previousSearchDate"));
      SelectRange(() => ({
        FromDate: prevDate.FromDate,
        ToDate: prevDate.ToDate,
      }));
      setForceRender((prev) => !prev);
    }
  }, [Range.FromDate, Range.ToDate]);

  React.useMemo(() => {
    if (Range.FromDate && Range.ToDate) {
      if (
        moment(SubstractMonth()).locale("fa").format("jYYYY/jM/jD") !==
        Range.FromDate
      ) {
        window.sessionStorage.setItem(
          "previousSearchDate",
          JSON.stringify({
            FromDate: Range.FromDate,
            ToDate: Range.ToDate,
          })
        );
      }
    }
  }, [Range.FromDate, Range.ToDate]);
};

export default useKeepSelectedDateRange;
